import React from "react"
import { FlexCenter, Padding } from "../../../styles/CommonStyles"
import { SOCKET_URL } from "../../../core/constants/urls"
import { BuyIcon, SellIcon, TextWithMargin } from "../../../styles/OrdersStyle"
import { ItemRow } from "../../../styles/newStyles/MobileModal.styled"
import { DetailText } from "../../../styles/TransactionHistoryStyles"
import { formatDate, formatNumber } from "../../../core/utils/common"
import Text from "../../../core/utils/Text"
import { useMainContext } from "../../../core/contexts/main"

const SwapHistoryDetailsModal = ({ data, onClose }) => {
    const {
        main: { lang },
    } = useMainContext()

    return (
        <div>
            <FlexCenter width="100%">
                <Padding
                    padding="10px 0"
                    style={{ borderBottom: "1px solid #ffffff15" }}
                >
                    <DetailText>
                        <Text tid="see-details" />
                    </DetailText>
                </Padding>
            </FlexCenter>

            <div className="p-2 bg-slate-100 dark:bg-transparent rounded-xl mb-4">
                {/* From → To currencies */}
                <ItemRow className="dark:border-b dark:border-card-border">
                    <Text tid="currency" className="text-pcolor-light text-sm" />
                    <FlexCenter className="gap-2">
                        <img
                            src={`${SOCKET_URL}assets/icon/${data.fromCurrency}.png`}
                            alt={data.fromCurrency}
                            width={20}
                            height={20}
                        />
                        <span>{data.fromCurrency?.toUpperCase()}</span>
                        <span className="mx-1">→</span>
                        <img
                            src={`${SOCKET_URL}assets/icon/${data.toCurrency}.png`}
                            alt={data.toCurrency}
                            width={20}
                            height={20}
                        />
                        <span>{data.toCurrency?.toUpperCase()}</span>
                    </FlexCenter>
                </ItemRow>

                {/* Amount */}
                <ItemRow className="dark:border-b dark:border-card-border">
                    <Text tid="amount" className="text-pcolor-light text-sm" />
                    <span> {`${formatNumber(data.amount)} (${data.fromCurrency?.toUpperCase()})`}</span>
                </ItemRow>

                {/* To Amount */}
                <ItemRow className="dark:border-b dark:border-card-border">
                    <Text tid="to-amount" className="text-pcolor-light text-sm" />
                    <span>{`${formatNumber(data.toAmount)} (${data.toCurrency?.toUpperCase()})`}</span>
                </ItemRow>

                {/* Wage */}
                <ItemRow className="dark:border-b dark:border-card-border">
                    <Text tid="wage" className="text-pcolor-light text-sm" />
                    <span>
                        {`${formatNumber(data.wage)} (${data.fromCurrency?.toUpperCase()})`}
                    </span>
                </ItemRow>

                {/* priceUnitFrom */}
                <ItemRow className="dark:border-b dark:border-card-border">
                    <Text tid="price-unit-from" className="text-pcolor-light text-sm" />
                    <span>{data.priceUnitFrom ? `${formatNumber(data.priceUnitFrom)} (${data.fromCurrency?.toUpperCase()})` : "--"}</span>
                </ItemRow>

                {/* priceUnitTo */}
                <ItemRow className="dark:border-b dark:border-card-border">
                    <Text tid="price-unit-to" className="text-pcolor-light text-sm" />
                    <span>{data.priceUnitTo ? `${formatNumber(data.priceUnitTo)} (${data.toCurrency?.toUpperCase()})` : "--"}</span>
                </ItemRow>

                {/* Transaction Type */}
                <ItemRow className="dark:border-b dark:border-card-border">
                    <Text tid="status" className="text-pcolor-light text-sm" />
                    <span
                        className={`px-2 py-1 rounded text-xs ${data.status === "done"
                            ? "bg-green-200 text-green-800"
                            : data.status === "pending"
                                ? "bg-yellow-200 text-yellow-800"
                                : "bg-red-200 text-red-800"
                            }`}
                    >
                        {data.status}
                    </span>
                </ItemRow>

                {/* Date & Time */}
                <ItemRow>
                    <Text tid="date-time" className="text-pcolor-light text-sm" />
                    <div className="flex flex-col items-end gap-1">
                        <span>
                            {formatDate(
                                data.createdAt,
                                "date",
                                lang === "en" ? "en-US" : "fa-IR"
                            )}
                        </span>
                        <span>
                            {formatDate(
                                data.createdAt,
                                "time",
                                lang === "en" ? "en-US" : "fa-IR"
                            )}
                        </span>
                    </div>
                </ItemRow>
            </div>
        </div>
    )
}

export default SwapHistoryDetailsModal
